import * as React from "react";
const SvgFiRrTerrace = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-terrace_svg__a)">
      <path d="M21.122 13A2.88 2.88 0 0 0 24 10.122a5.13 5.13 0 0 0-2.106-4.137L15.009.98a5.1 5.1 0 0 0-6.018 0L2.106 5.985A5.13 5.13 0 0 0 0 10.122 2.88 2.88 0 0 0 2.878 13H11v10a1 1 0 0 0 2 0V13zM15.5 8.075c.327.492.501 1.07.5 1.66V11h-3V4.313zm5.218-.475A3.12 3.12 0 0 1 22 10.122a.88.88 0 0 1-.878.878H18V9.734c0-.984-.29-1.946-.835-2.766l-2.5-3.77zM2 10.122A3.12 3.12 0 0 1 3.282 7.6l6.057-4.4-2.5 3.77A5 5 0 0 0 6 9.734V11H2.878A.88.88 0 0 1 2 10.122M8 11V9.734a3 3 0 0 1 .5-1.659L11 4.313V11zM4 19H2v-3a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0v-2h2a1 1 0 0 1 1 1v1a1 1 0 1 0 2 0v-1a3 3 0 0 0-3-3M23 15a1 1 0 0 0-1 1v3h-2a3 3 0 0 0-3 3v1a1 1 0 0 0 2 0v-1a1 1 0 0 1 1-1h2v2a1 1 0 0 0 2 0v-7a1 1 0 0 0-1-1" />
    </g>
    <defs>
      <clipPath id="fi-rr-terrace_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTerrace;
